import {Component, Input, OnInit} from '@angular/core';
import {ModalController} from "@ionic/angular";
import {AppStateService} from "../../providers/app-state.service";
import {CommonUtils} from "../../utils/common";
import {Client} from "../../models/client.model";
import {ClientsService} from "../../providers/clients.service";
import {VetClinicService} from "../../providers/vet-clinic.service";
import {VetClinic} from "../../models/vet-clinic.model";

@Component({
  selector: 'app-select-client',
  templateUrl: './select-client.component.html',
  styleUrls: ['./select-client.component.scss'],
})
export class SelectClientComponent implements OnInit {


  @Input() veClinicUUID: string;
  clients: Client[];

  isBusy: boolean;

  constructor(
    private modalController: ModalController,
    private appStateService: AppStateService,
    public commonUtils : CommonUtils,
    private vClientService: ClientsService,
    private vetClinicService: VetClinicService
  ) {
  }

  ngOnInit() {
    this.appStateService.isBusySubject.subscribe(e => {
      this.isBusy = e;
    });
    this.vClientService.listAllClients().subscribe(e => {
      if (e) {
        this.clients = e;
      }
    })
  }

  onSelect(uuid) {
    let vetClinic = new VetClinic();
    vetClinic.uuid = this.veClinicUUID;
    this.vetClinicService.switchClient(vetClinic, uuid).subscribe(e => {
      if (e) {
        this.modalController.dismiss(e).then(() => {
        });
      }
    })

  }

  onClose() {
    if (!this.isBusy) {
      this.modalController.dismiss(null).then(() => {
      });
    }
  }
}
